import { useEffect, useState } from "react";
import { api, money } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = ["", "pending", "processing", "paid", "failed", "cancelled", "refunded"];
const FULFILL = ["unfulfilled", "processing", "shipped", "delivered"];

export default function OrderManager() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");
  const [detail, setDetail] = useState(null);
  const load = () => api.get("/admin/orders", { params: filter ? { status: filter } : {} }).then(({ data }) => setOrders(data)).catch(() => {});
  useEffect(() => { load(); }, [filter]);
  const setFulfill = async (o, fs) => { await api.put(`/admin/orders/${o.order_number}`, null, { params: { fulfillment_status: fs } }); toast.success("Güncellendi."); load(); };

  return (
    <div data-testid="admin-orders">
      <h1 className="font-serif text-4xl text-brand-green mb-6">Siparişler</h1>
      <div className="flex gap-2 mb-6 flex-wrap">
        {STATUSES.map((s) => <button key={s || "all"} onClick={() => setFilter(s)} className={`px-4 py-2 text-sm rounded-full border ${filter === s ? "bg-brand-green text-brand-offwhite" : "bg-brand-offwhite border-brand-gold-light/40"}`}>{s || "Tümü"}</button>)}
      </div>
      <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-cream text-brand-green text-left"><tr><th className="p-3">Sipariş No</th><th className="p-3">Müşteri</th><th className="p-3">Tutar</th><th className="p-3">Ödeme</th><th className="p-3">Kargo</th><th className="p-3">Tarih</th></tr></thead>
          <tbody>{orders.map((o) => (
            <tr key={o.id} data-testid={`admin-order-${o.order_number}`} className="border-t border-brand-gold-light/30 cursor-pointer hover:bg-brand-cream/40" onClick={() => setDetail(o)}>
              <td className="p-3 font-medium text-brand-green">{o.order_number}</td>
              <td className="p-3 text-brand-text/70">{o.full_name}<br /><span className="text-xs text-brand-text/50">{o.email}</span></td>
              <td className="p-3">{money(o.total)}</td>
              <td className="p-3"><span className={`text-xs px-2 py-1 rounded-full ${o.status === "paid" ? "bg-brand-green text-brand-offwhite" : "bg-brand-gold-light text-brand-green"}`}>{o.status}</span></td>
              <td className="p-3" onClick={(e) => e.stopPropagation()}>
                <select value={o.fulfillment_status} onChange={(e) => setFulfill(o, e.target.value)} className="text-xs border border-brand-gold-light/50 rounded px-2 py-1 bg-white">{FULFILL.map((f) => <option key={f}>{f}</option>)}</select>
              </td>
              <td className="p-3 text-brand-text/50 text-xs">{(o.created_at || "").slice(0, 10)}</td>
            </tr>))}
          </tbody>
        </table>
        {orders.length === 0 && <p className="p-6 text-brand-text/50 text-sm">Sipariş yok.</p>}
      </div>

      {detail && (
        <div className="fixed inset-0 bg-brand-green/50 flex items-center justify-center z-50 p-6" onClick={() => setDetail(null)}>
          <div className="bg-brand-offwhite rounded-sm p-8 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-serif text-2xl text-brand-green">{detail.order_number}</h3>
            <p className="text-sm text-brand-text/60 mb-4">{detail.full_name} · {detail.email} · {detail.phone}</p>
            <div className="space-y-1 text-sm">{detail.items.map((i, x) => <div key={x} className="flex justify-between"><span>{i.name} × {i.quantity}</span><span>{money(i.line_total)}</span></div>)}</div>
            <div className="border-t border-brand-gold-light/30 mt-3 pt-3 flex justify-between font-semibold text-brand-green"><span>Toplam</span><span>{money(detail.total)}</span></div>
            {detail.address?.address && <p className="text-sm text-brand-text/60 mt-3">{detail.address.address}, {detail.address.district} {detail.address.city} {detail.address.postal_code}</p>}
            <button onClick={() => setDetail(null)} className="mt-5 border border-brand-gold-light px-6 py-2 rounded-sm text-sm">Kapat</button>
          </div>
        </div>
      )}
    </div>
  );
}
